// Recurrence labels/config shared by the dialog and the lists.
export const RECURRENCE_TYPES = [
  'once',
  'daily',
  'weekly',
  'monthly',
  'yearly',
];

export const emptyRecurrence = () => ({
  type: 'once',
  days_of_week: [],
  day_of_month: '',
  end_date: '',
  max_executions: '',
});

export const toApiRecurrence = form => {
  if (!form || form.type === 'once') return null;
  const out = { type: form.type };
  if (form.type === 'weekly') out.days_of_week = form.days_of_week.map(Number);
  if (form.type === 'monthly' && form.day_of_month)
    out.day_of_month = Number(form.day_of_month);
  if (form.end_date) out.end_date = form.end_date;
  if (form.max_executions) out.max_executions = Number(form.max_executions);
  return out;
};

export const fromApiRecurrence = recurrence => {
  if (!recurrence) return emptyRecurrence();
  return {
    type: recurrence.type || 'once',
    days_of_week: recurrence.days_of_week || [],
    day_of_month: recurrence.day_of_month || '',
    end_date: recurrence.end_date || '',
    max_executions: recurrence.max_executions || '',
  };
};

export const recurrenceSummary = (recurrence, t) => {
  if (!recurrence) return t('WASAPI_SCHEDULER.RECURRENCE.ONCE');
  const key = `WASAPI_SCHEDULER.RECURRENCE.${(recurrence.type || 'once').toUpperCase()}`;
  let text = t(key);
  if (recurrence.type === 'weekly') {
    const days = (recurrence.days_of_week || [])
      .map(d => t(`WASAPI_SCHEDULER.RECURRENCE.WEEKDAYS.${d}`))
      .join(', ');
    text = `${text} (${days})`;
  }
  if (recurrence.type === 'monthly' && recurrence.day_of_month) {
    text = `${text} (${t('WASAPI_SCHEDULER.RECURRENCE.DAY', { day: recurrence.day_of_month })})`;
  }
  return text;
};
